module.exports = __webpack_public_path__ + "static/doctor-heart-mobile-dd535756fe247c362fb49bf9d0e5bc5d.png";